(() => {
  /* BEZELOR cart page helpers (styles in bezelor-cart-page.css).
     1) Quick checkout bonus: an extra 2% for 5 minutes. It is a real discount code (QUICKCHECKOUT2) put on the cart, so the total on the page
        and at checkout match. When the 5 minutes end the code is taken off again. Nothing else about the cart ever expires.
     2) Select all / pick which watches go into this order. Watches that are ticked off are set aside on this device and can be ticked back in.
     3) Savings line, payment cards, suggestion rail refresh, item count, and the floating checkout bar on phones. */
  if (window.__bzCartPage) return;
  window.__bzCartPage = true;
  const page = document.querySelector('cart-items');
  const footer = document.getElementById('main-cart-footer');
  if (!page || !footer) return;

  const CODE = 'QUICKCHECKOUT2';
  const DURATION = 5 * 60 * 1000;
  const Q_KEY = 'bz_q_v1';
  const OFF_KEY = 'bz_cart_off_v1';
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const icon = (d) => '<svg viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>';
  const TAG = '<path d="M20.6 13.2 13.2 20.6a2 2 0 0 1-2.8 0L3.4 13.6a2 2 0 0 1 0-2.8V4h6.8a2 2 0 0 1 1.4.6l7 7a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.25"/>';
  const CHECK = '<path d="m5 12.5 4.2 4.2L19 7"/>';
  const CLOCK = '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>';
  const ARROW = '<path d="M5 12h14M13 6l6 6-6 6"/>';
  const esc = (t) => String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const store = {
    get(key, fallback) { try { const v = JSON.parse(localStorage.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* ignore */ } }
  };
  const getCart = () => fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
  const post = (path, body) => fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());

  let toastTimer;
  const toast = (text) => {
    let el = document.querySelector('.bzc-toast');
    if (!el) { el = document.createElement('div'); el.className = 'bzc-toast'; el.setAttribute('role', 'status'); document.body.append(el); }
    el.textContent = text;
    requestAnimationFrame(() => el.classList.add('is-on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2800);
  };

  /* Redraw the item list and summary from the server (same sections the theme redraws itself) */
  const refreshSections = async () => {
    const itemsEl = document.getElementById('main-cart-items');
    const list = [['main-cart-items', itemsEl && itemsEl.dataset.id], ['main-cart-footer', footer.dataset.id]].filter((x) => x[1]);
    const data = await fetch(root() + '?sections=' + list.map((x) => x[1]).join(','), { cache: 'no-store' }).then((r) => r.json());
    list.forEach(([id, sid]) => {
      const el = document.getElementById(id);
      const target = el && (el.querySelector('.js-contents') || el);
      const src = new DOMParser().parseFromString(data[sid] || '', 'text/html').querySelector('.js-contents');
      if (target && src) target.innerHTML = src.innerHTML;
    });
  };

  /* ---------- Quick checkout bonus ---------- */
  const bzq = document.querySelector('[data-bzq]'); /* the bonus timer lives in the checkout column */
  let q = null;
  let tick = null;
  const codesWith = (cart, add) => {
    const keep = (cart.discount_codes || []).map((d) => d.code).filter((c) => c && c.toUpperCase() !== CODE);
    return (add ? keep.concat(CODE) : keep).join(',');
  };
  /* The 2% bonus combines with every other discount (bundle offers, Super Deals, promo codes), so it stays on while a promo code is used.
     Customers cannot remove it: it only ends when the 5 minutes run out. */
  const hasCode = (cart) => (cart.discount_codes || []).some((d) => d.code && d.code.toUpperCase() === CODE);
  const mmss = (ms) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
  };
  const paintTimer = () => {
    if (!q) return;
    const left = q.start + DURATION - Date.now();
    if (left <= 0) { endBonus(); return; }
    const text = mmss(left);
    if (bzq) {
      bzq.style.setProperty('--bzq-p', (left / DURATION).toFixed(4));
      bzq.classList.toggle('is-urgent', left < 120000);
      const b = bzq.querySelector('.bzq__time');
      if (b && b.textContent !== text) b.textContent = text;
    }
    const chip = document.querySelector('.bz-cart-sticky__chip span');
    if (chip && chip.textContent !== text) chip.textContent = text + ' · extra 2% off';
  };
  const showBonus = (on) => {
    if (bzq && !bzq.classList.contains('is-ended')) bzq.hidden = !on;
    const chip = document.querySelector('.bz-cart-sticky__chip');
    if (chip) chip.hidden = !on;
  };
  const showEnded = () => {
    if (!bzq) return;
    bzq.classList.add('is-ended');
    bzq.classList.remove('is-urgent');
    bzq.innerHTML =
      '<div class="bzq__ic">' + icon(CLOCK) + '</div>' +
      '<div class="bzq__txt"><strong>Quick checkout bonus ended</strong><small>Your watches are still in your cart. Add another watch to start a new 5-minute bonus.</small></div>';
    bzq.hidden = false;
  };
  async function endBonus() {
    clearInterval(tick);
    tick = null;
    if (q) { q.done = true; store.set(Q_KEY, q); }
    showBonus(false);
    try {
      const cart = await getCart();
      if (hasCode(cart)) { await post('cart/update.js', { discount: codesWith(cart, false) }); await refreshSections(); }
    } catch (e) { /* ignore */ }
    q = null;
    showEnded();
  }
  async function startBonus() {
    if (!bzq) return;
    let cart;
    try { cart = await getCart(); } catch (e) { return; }
    if (!cart.item_count) return;
    clearInterval(tick);
    tick = null;
    q = store.get(Q_KEY, null);
    const last = store.get('bz_q_last', null);
    store.set('bz_q_last', cart.item_count);
    if (q && q.done && last != null && cart.item_count > last) q = null; /* a watch was added since the timer ended: start a fresh one */
    if (q && q.done && (cart.item_count > (q.qty || 0) || Date.now() - q.start > 864e5)) q = null; /* cart grew or a day passed: offer the bonus again */
    if (!q || q.token !== cart.token) { q = { token: cart.token, start: Date.now(), done: false, qty: cart.item_count }; store.set(Q_KEY, q); }
    if (q.done || Date.now() - q.start >= DURATION) {
      q.done = true; store.set(Q_KEY, q);
      if (hasCode(cart)) { await post('cart/update.js', { discount: codesWith(cart, false) }).catch(() => {}); await refreshSections().catch(() => {}); }
      q = null;
      showEnded();
      return;
    }
    if (!hasCode(cart)) {
      const res = await post('cart/update.js', { discount: codesWith(cart, true) }).catch(() => null);
      const ok = res && (res.discount_codes || []).some((d) => d.code && d.code.toUpperCase() === CODE && d.applicable !== false);
      if (!ok) {
        /* the bonus cannot apply to this cart (for example a Super Deal is in it): show nothing and make sure no stray code is left */
        if (res && (res.discount_codes || []).some((d) => d.code && d.code.toUpperCase() === CODE)) await post('cart/update.js', { discount: codesWith(res, false) }).catch(() => {});
        q = null;
        return;
      }
      await refreshSections().catch(() => {});
    }
    bzq.classList.remove('is-ended');
    if (!bzq.querySelector('.bzq__time')) {
      bzq.innerHTML =
        '<div class="bzq__top"><span class="bzq__live"><i></i>Quick checkout bonus</span><span class="bzq__badge">Extra 2% off</span></div>' +
        '<div class="bzq__main"><div class="bzq__clock" aria-hidden="true">' + icon(CLOCK) + '</div>' +
        '<div class="bzq__count"><b class="bzq__time" role="timer" aria-live="off">05:00</b><small>min left</small></div>' +
        '<p class="bzq__txt"><strong>An extra <em>2% off</em> is reserved for you</strong><small>It stacks with every other saving. Check out before the timer ends to keep it.</small></p></div>' +
        '<div class="bzq__bar" aria-hidden="true"><span></span></div>';
    }
    showBonus(true);
    paintTimer();
    tick = setInterval(paintTimer, 1000);
  }

  /* The promo-code box (assets/bezelor-cart-promo.js) tells us when a code was added or removed */
  document.addEventListener('bz:promo-changed', () => { startBonus().catch(() => {}).then(() => { buildSticky(); syncSticky(); }); });

  /* ---------- Count, select all, set aside ---------- */
  const ROWS = 'tr.bzx-item';
  const countItems = () => [...page.querySelectorAll(ROWS + ' .quantity__input')].reduce((s, i) => s + (parseInt(i.value, 10) || 0), 0);
  const count = () => {
    const el = page.querySelector('[data-bzc-count]');
    const n = countItems();
    if (el) el.textContent = n + (n === 1 ? ' watch' : ' watches');
  };
  const off = () => store.get(OFF_KEY, []);
  const renderBar = () => {
    const bar = page.querySelector('[data-bzsel-bar]');
    if (!bar) return;
    const rows = page.querySelectorAll(ROWS).length;
    const n = countItems();
    const aside = off().length;
    if (!rows) { bar.hidden = true; return; }
    bar.hidden = false;
    const html =
      '<label class="bzsel-bar__all"><span class="bzc-check"><input type="checkbox" data-bzsel-all ' + (aside ? '' : 'checked') + ' aria-label="Select all watches"><span aria-hidden="true">' + icon(CHECK) + '</span></span>Select all</label>' +
      '<span class="bzsel-bar__note">' + (aside ? n + ' in this order · ' + aside + ' set aside' : n + (n === 1 ? ' watch' : ' watches') + ' in this order') + '</span>';
    if (bar.dataset.h !== html) { bar.innerHTML = html; bar.dataset.h = html; }
  };
  const renderSaved = () => {
    const box = page.querySelector('[data-bzsel-saved]');
    if (!box) return;
    const list = off();
    const live = page.querySelectorAll(ROWS).length;
    page.classList.toggle('has-aside', list.length > 0 && !live);
    if (!list.length) { if (box.dataset.h) { box.dataset.h = ''; box.innerHTML = ''; } box.hidden = true; return; }
    box.hidden = false;
    const head = live
      ? '<div class="bzsel-saved__head"><h2>Set aside</h2><p>Not in this order. Tick to add back.</p></div>'
      : '<div class="bzsel-bar"><label class="bzsel-bar__all"><span class="bzc-check"><input type="checkbox" data-bzsel-all aria-label="Select all watches"><span aria-hidden="true">' + icon(CHECK) + '</span></span>Select all</label><span class="bzsel-bar__note">0 in this order &middot; ' + list.length + ' set aside</span></div>' +
        '<p class="bzsel-saved__hint">Your watches are saved here. Tick one to add it to your order.</p>';
    const html = head + '<ul class="bzsel-saved__list">' +
      list.map((it, i) =>
        '<li><div class="bzc-item"><label class="bzc-check"><input type="checkbox" data-bz-back="' + i + '" aria-label="Add ' + esc(it.t) + ' back to this order"><span aria-hidden="true">' + icon(CHECK) + '</span></label>' +
        '<a class="bzc-item__img" href="' + esc(it.u) + '" tabindex="-1" aria-hidden="true">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
        '<div class="bzc-item__body"><span class="bzc-item__brand">' + esc(it.v) + '</span><a class="bzc-item__name" href="' + esc(it.u) + '">' + esc(it.t) + '</a>' +
        (it.vt ? '<p class="bzc-item__var">' + esc(it.vt) + '</p>' : '') +
        '<div class="bzc-item__foot"><span class="bzc-item__qty">Qty ' + esc(it.q) + '</span><div class="bzc-item__price"><b>' + esc(it.pm) + '</b></div></div></div></div></li>'
      ).join('') + '</ul>';
    if (box.dataset.h !== html) { box.innerHTML = html; box.dataset.h = html; }
  };
  const itemData = (row) => { try { return JSON.parse(row.dataset.bzItem); } catch (e) { return null; } };
  const setAside = (rows) => {
    const saved = off();
    rows.forEach((row) => { const d = itemData(row); if (d) saved.push(d); });
    store.set(OFF_KEY, saved);
  };
  const restore = async (index) => {
    const saved = off();
    const it = saved[index];
    if (!it) return;
    const box = page.querySelector('[data-bzsel-saved]');
    if (box) box.classList.add('is-busy');
    const props = it.props && typeof it.props === 'object' && !Array.isArray(it.props) ? it.props : {};
    const res = await post('cart/add.js', { items: [{ id: it.id, quantity: it.q, properties: props }] }).catch(() => null);
    if (!res || res.status) { toast('Sorry, that watch is no longer available in that quantity.'); if (box) box.classList.remove('is-busy'); return; }
    saved.splice(index, 1);
    store.set(OFF_KEY, saved);
    window.location.reload();
  };

  page.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches && input.matches('[data-bzsel]') && !input.checked) {
      event.stopPropagation();
      const row = input.closest('.bzx-item');
      setAside([row]);
      toast('Set aside. Tick it again to add it back.');
      if (typeof page.updateQuantity === 'function') page.updateQuantity(input.dataset.line, 0, { currentTarget: null, target: input });
      setTimeout(() => { renderBar(); renderSaved(); }, 600);
      return;
    }
    if (input.matches && input.matches('[data-bzsel-all]')) {
      event.stopPropagation();
      if (input.checked) {
        const list = off();
        if (!list.length) return;
        post('cart/add.js', { items: list.map((it) => ({ id: it.id, quantity: it.q, properties: it.props && !Array.isArray(it.props) ? it.props : {} })) })
          .then(() => { store.set(OFF_KEY, []); window.location.reload(); })
          .catch(() => toast('Sorry, we could not add those back.'));
      } else {
        setAside([...page.querySelectorAll(ROWS)]);
        post('cart/clear.js', {}).then(() => window.location.reload()).catch(() => {});
      }
      return;
    }
    if (input.matches && input.matches('[data-bz-back]')) { event.stopPropagation(); restore(Number(input.dataset.bzBack)); }
  }, true);

  /* ---------- Quantity: friendly limits instead of the browser's own pop-up ---------- */
  const rowError = (input, text) => {
    const row = input.closest(ROWS);
    const box = row && row.querySelector('.cart-item__error-text');
    if (!box) return;
    box.textContent = text;
    clearTimeout(box.bzT);
    box.bzT = setTimeout(() => { if (box.textContent === text) box.textContent = ''; }, 6000);
  };
  /* Shopify's stock message, said the BEZELOR way */
  const brandErrors = () => {
    page.querySelectorAll(ROWS + ' .cart-item__error-text').forEach((el) => {
      const m = el.textContent.match(/only add (\d+) of this item/i);
      if (!m) return;
      const n = Number(m[1]);
      el.textContent = n === 1 ? 'This is the last one in stock, so 1 is the most you can order.' : 'Only ' + n + ' left in stock, so ' + n + ' is the most you can order.';
    });
  };
  const reset = (input) => { input.value = input.getAttribute('value') || input.defaultValue || '1'; };
  /* a quantity below the minimum (for example 0 typed in) is not sent: the watch stays and the Remove link is pointed out */
  page.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches(ROWS + ' .quantity__input')) return;
    const value = parseInt(input.value, 10);
    const min = parseInt(input.dataset.min, 10) || 1;
    if (Number.isNaN(value) || value < min) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      reset(input);
      rowError(input, 'To take this watch out of your order, use Remove.');
    }
  }, true);
  /* any other rule the theme checks (maximum, step) is shown in the BEZELOR style, not as a browser bubble */
  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches(ROWS + ' .quantity__input')) return;
    event.preventDefault();
    rowError(input, input.validationMessage || 'That quantity is not available.');
  }, true);

  /* ---------- Order summary: savings and payment cards ---------- */
  const savings = () => { const l = footer.querySelector('.bz-cart-saved'); if (l) l.remove(); };
  const extras = () => {
    const slot = footer.querySelector('[data-bz-pay-slot]');
    const tpl = document.getElementById('BzPayIcons');
    if (slot && tpl && !slot.firstElementChild) slot.append(tpl.content.cloneNode(true));
  };

  /* ---------- Floating checkout bar (phones) ---------- */
  let sticky;
  const buildSticky = () => {
    if (sticky || !document.getElementById('checkout')) return;
    sticky = document.createElement('div');
    sticky.className = 'bz-cart-sticky';
    sticky.innerHTML =
      '<div class="bz-cart-sticky__float"><span class="bz-cart-sticky__chip" hidden>' + icon(CLOCK) + '<span></span></span>' +
      '<div class="bz-cart-sticky__bar"><div class="bz-cart-sticky__total"><small>Total</small><strong></strong></div>' +
      '<button type="button" class="bz-cart-sticky__btn">Checkout<i>' + icon(ARROW) + '</i></button></div></div><span class="bz-cart-sticky__shadow" aria-hidden="true"></span>';
    sticky.querySelector('button').addEventListener('click', () => {
      const b = document.getElementById('checkout');
      if (b && !b.disabled) b.click();
    });
    document.body.append(sticky);
    const update = () => {
      const empty = page.classList.contains('is-empty') || !page.querySelector(ROWS);
      const b = document.getElementById('checkout');
      const r = b ? b.getBoundingClientRect() : null;
      const btnVisible = !!r && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
      const ie = page.querySelector('.cart__items');
      const ir = ie ? ie.getBoundingClientRect() : null;
      sticky.classList.toggle('is-on', !empty && !btnVisible && !!ir && (ir.bottom > 0 || ir.top < 0));
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    sticky.bzUpdate = update;
    update();
    showBonus(!!q);
    paintTimer();
  };
  const syncSticky = () => {
    if (!sticky) return;
    const value = footer.querySelector('.totals__total-value');
    sticky.querySelector('strong').textContent = value ? value.textContent.trim() : '';
    sticky.bzUpdate();
  };

  /* ---------- Suggestion rail: rebuilt for the current cart ---------- */
  const sig = () => [...page.querySelectorAll(ROWS + ' .bzx-item__name')].map((a) => a.getAttribute('href')).join('|') + '#' + [...page.querySelectorAll(ROWS + ' .quantity__input')].map((i) => i.value).join(',');
  let railSig = sig();
  let railTimer;
  const refreshRail = () => {
    const now = sig();
    if (now === railSig) return;
    railSig = now;
    clearTimeout(railTimer);
    railTimer = setTimeout(() => {
      const id = document.getElementById('main-cart-items')?.dataset.id;
      if (!id) return;
      fetch(root() + '?sections=' + encodeURIComponent(id)).then((r) => r.json()).then((data) => {
        const fresh = new DOMParser().parseFromString(data[id] || '', 'text/html').querySelector('[data-bzc-after]');
        const old = page.querySelector('[data-bzc-after]');
        if (fresh && old) old.replaceWith(fresh);
      }).catch(() => {});
    }, 350);
  };

  let queued = false;
  let restarting = false;
  let seen = countItems();
  const maybeRestart = () => {
    const n = countItems();
    const grew = n > seen;
    seen = n;
    store.set('bz_q_last', n);
    if (restarting || !bzq || !bzq.classList.contains('is-ended')) return;
    const st = store.get(Q_KEY, null);
    if (!grew && (!st || n <= (st.qty || 0))) return;
    store.set(Q_KEY, null); /* a watch was added: start a fresh timer */
    restarting = true;
    startBonus().catch(() => {}).then(() => { restarting = false; });
  };
  const refresh = () => {
    maybeRestart();
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      brandErrors();
      count();
      renderBar();
      renderSaved();
      extras();
      syncSticky();
      refreshRail();
    });
  };
  count();
  renderBar();
  renderSaved();
  extras();
  buildSticky();
  syncSticky();
  savings();
  startBonus().then(() => { buildSticky(); syncSticky(); });
  new MutationObserver(refresh).observe(page, { childList: true, subtree: true });
  new MutationObserver(refresh).observe(footer, { childList: true, subtree: true, characterData: true });
})();

